import { UserRolePostRequestBody } from '@lio/api-types';
import { userQueryKey } from '@services/user/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateUserRole = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = (params: {
    requestBody: UserRolePostRequestBody;
    requestParams: {
      userId: string;
    };
  }) => {
    const { requestBody, requestParams } = params;
    const url = `user/${requestParams.userId}/role`;
    return client.post(url, {
      json: requestBody,
    });
  };
  const result = useMutation({
    mutationFn,
    onSuccess: (data, request) => {
      const { requestParams } = request;
      queryClient.invalidateQueries({
        queryKey: userQueryKey.search,
      });
      queryClient.invalidateQueries({
        queryKey: userQueryKey.getWithParams(requestParams.userId),
      });
    },
  });
  return { ...result, createUserRole: result.mutateAsync };
};
